module.exports = __webpack_public_path__ + "static/P+Q_lm-bdd8b6590d498ec784722ea983fc97f9.png";